const locMap = {
  french: {
    'I’m new': 'Je suis nouveau sur ce site.',
    'Log in': 'Se connecter.',
    'Sign up with Google': 'S’inscrire avec Google.',
    'Sign up with Clever': 'S’inscrire avec Clever.',
    'Create account': 'Créer un compte.',
    'Enter your class code': 'Entrez votre code de classe',
    'First name': 'Prénom',
    'Last name': 'Nom de famille',
    Summary: 'Récapitulatif',
    'I agree to Ellii’s terms':
      'J’accepte les conditions et la politique de confidentialité.',
    'Ellii Student Login Page': 'Page de connexion pour les étudiants d’Ellii',
    'What’s your name?': 'Comment vous appelez-vous?',
    'What’s your email?': 'Quel est votre email?',
    'Welcome back!': 'Bienvenue à nouveau!',
    'Terms and Conditions': 'Conditions générales',
    'Create an Ellii student account': 'Créez un compte étudiant Ellii',
    Email: 'Email',
    Password: 'Mot de passe',
    'Create a password': 'Créer un mot de passe',
    'Log in with Google': 'Se connecter avec Google',
    'Log in with Clever': 'Se connecter avec Clever',
    Welcome: 'Bienvenue',
  },
  japanese: {
    'I’m new': 'このサイトは初めてです',
    'Log in': 'ログインする',
    'Sign up with Google': 'Googleでサインアップする',
    'Sign up with Clever': 'Cleverでサインアップする',
    'Create account': 'アカウントを作成する',
    'Enter your class code': 'クラスコードを入力してください',
    'First name': '名前',
    'Last name': '姓',
    Summary: 'まとめ',
    'I agree to Ellii’s terms': '利用規約とプライバシーポリシーに同意します',
    'Ellii Student Login Page': 'Elliiの学生ログインページ',
    'What’s your name?': 'お名前は何ですか?',
    'What’s your email?': 'あなたのメールは何ですか？',
    'Welcome back!': 'おかえりなさい！',
    'Terms and Conditions': '利用規約',
    'Create an Ellii student account': 'Ellii学生アカウントを作成する',
    Email: 'メール',
    Password: 'パスワード',
    'Create a password': 'パスワードを作成する',
    'Log in with Google': 'Googleでログインする',
    'Log in with Clever': 'Cleverでログインする',
    Welcome: 'ようこそ',
  },
  korean: {
    'I’m new': '이 사이트는 처음입니다',
    'Log in': '로그인',
    'Sign up with Google': 'Google로 가입하기',
    'Sign up with Clever': 'Clever로 가입하기',
    'Create account': '계정을 만들다',
    'Enter your class code': '클래스 코드를 입력하십시오',
    'First name': '이름',
    'Last name': '성',
    Summary: '요약',
    'I agree to Ellii’s terms': '이용 약관 및 개인정보 처리방침에 동의합니다',
    'Ellii Student Login Page': 'Ellii 학생 로그인 페이지',
    'What’s your name?': '이름이 무엇입니까?',
    'What’s your email?': '이메일은 무엇입니까?',
    'Welcome back!': '다시 오신 것을 환영합니다!',
    'Terms and Conditions': '이용 약관',
    'Create an Ellii student account': 'Ellii 학생 계정을 만드십시오',
    Email: '이메일',
    Password: '비밀번호',
    'Create a password': '비밀번호를 생성하십시오',
    'Log in with Google': 'Google로 로그인하십시오',
    'Log in with Clever': 'Clever로 로그인하십시오',
    Welcome: '환영합니다',
  },
  chinese: {
    'I’m new': '我是这个网站的新用户',
    'Log in': '登录',
    'Sign up with Google': '用Google注册',
    'Sign up with Clever': '用Clever注册',
    'Create account': '创建账户',
    'Enter your class code': '输入您的班级代码',
    'First name': '名字',
    'Last name': '姓',
    Summary: '总结',
    'I agree to Ellii’s terms': '我同意服务条款和隐私政策',
    'Ellii Student Login Page': 'Ellii学生登录页面',
    'What’s your name?': '你叫什么名字?',
    'What’s your email?': '你的电子邮件是什么？',
    'Welcome back!': '欢迎回来！',
    'Terms and Conditions': '服务条款',
    'Create an Ellii student account': '创建一个Ellii学生账户',
    Email: '电子邮件',
    Password: '密码',
    'Create a password': '创建密码',
    'Log in with Google': '用Google登录',
    'Log in with Clever': '用Clever登录',
    Welcome: '欢迎',
  },
  russian: {
    'I’m new': 'Я новичок на этом сайте',
    'Log in': 'Вход',
    'Sign up with Google': 'Зарегистрироваться через Google',
    'Sign up with Clever': 'Зарегистрироваться через Clever',
    'Create account': 'Создать аккаунт',
    'Enter your class code': 'Введите код вашего класса',
    'First name': 'Имя',
    'Last name': 'Фамилия',
    Summary: 'Итог',
    'I agree to Ellii’s terms':
      'Я согласен с условиями и политикой конфиденциальности',
    'Ellii Student Login Page': 'Страница входа для студентов Ellii',
    'What’s your name?': 'Как тебя зовут?',
    'What’s your email?': 'Какой у вас адрес электронной почты?',
    'Welcome back!': 'Добро пожаловать обратно!',
    'Terms and Conditions': 'Условия и положения',
    'Create an Ellii student account': 'Создайте учебный аккаунт Ellii',
    Email: 'Электронная почта',
    Password: 'Пароль',
    'Create a password': 'Создать пароль',
    'Log in with Google': 'Войти через Google',
    'Log in with Clever': 'Войти через Clever',
    Welcome: 'Добро пожаловать',
  },
  ukrainian: {
    'I’m new': 'Я новий на цьому сайті',
    'Log in': 'Увійти',
    'Sign up with Google': 'Зареєструватися через Google',
    'Sign up with Clever': 'Зареєструватися через Clever',
    'Create account': 'Створити обліковий запис',
    'Enter your class code': 'Введіть код вашого класу',
    'First name': 'Ім&’я',
    'Last name': 'Прізвище',
    Summary: 'Підсумок',
    'I agree to Ellii’s terms':
      'Я погоджуюсь з умовами та політикою конфіденційності',
    'Ellii Student Login Page': 'Сторінка входу для студентів Ellii',
    'What’s your name?': 'Як вас звати?',
    'What’s your email?': 'Яка ваша електронна пошта?',
    'Welcome back!': 'Ласкаво просимо назад!',
    'Terms and Conditions': 'Умови та положення',
    'Create an Ellii student account': 'Створити аккаунт студента Ellii',
    Email: 'Електронна пошта',
    Password: 'Пароль',
    'Create a password': 'Створити пароль',
    'Log in with Google': 'Увійти через Google',
    'Log in with Clever': 'Увійти через Clever',
    Welcome: 'Ласкаво просимо',
  },
  spanish: {
    'I’m new': 'Soy nuevo en este sitio',
    'Log in': 'Iniciar sesión',
    'Sign up with Google': 'Regístrate con Google',
    'Sign up with Clever': 'Regístrate con Clever',
    'Create account': 'Crear una cuenta',
    'Enter your class code': 'Ingresa tu código de clase',
    'First name': 'Nombre',
    'Last name': 'Apellido',
    Summary: 'Resumen',
    'I agree to Ellii’s terms':
      'Acepto los términos y la política de privacidad',
    'Ellii Student Login Page':
      'Página de inicio de sesión para estudiantes de Ellii',
    'What’s your name?': '¿Cómo te llamas?',
    'What’s your email?': '¿Cuál es tu correo electrónico?',
    'Welcome back!': '¡Bienvenido de nuevo!',
    'Terms and Conditions': 'Términos y condiciones',
    'Create an Ellii student account': 'Crea una cuenta de estudiante de Ellii',
    Email: 'Correo electrónico',
    Password: 'Contraseña',
    'Create a password': 'Crea una contraseña',
    'Log in with Google': 'Inicia sesión con Google',
    'Log in with Clever': 'Inicia sesión con Clever',
    Welcome: 'Bienvenido',
  },
  portuguese: {
    'I’m new': 'Sou novo neste site',
    'Log in': 'Entrar',
    'Sign up with Google': 'Inscreva-se com o Google',
    'Sign up with Clever': 'Inscreva-se com o Clever',
    'Create account': 'Criar uma conta',
    'Enter your class code': 'Digite o seu código de classe',
    'First name': 'Nome',
    'Last name': 'Sobrenome',
    Summary: 'Resumo',
    'I agree to Ellii’s terms':
      'Concordo com os termos e a política de privacidade',
    'Ellii Student Login Page': 'Página de login para estudantes da Ellii',
    'What’s your name?': 'Qual é o seu nome',
    'What’s your email?': 'Qual é o seu email',
    'Welcome back!': 'Bem-vindo de volta',
    'Terms and Conditions': 'Termos e condições',
    'Create an Ellii student account': 'Crie uma conta de estudante Ellii',
    Email: 'Email',
    Password: 'Senha',
    'Create a password': 'Criar uma senha',
    'Log in with Google': 'Entrar com o Google',
    'Log in with Clever': 'Entrar com o Clever',
    Welcome: 'Bem-vindo',
  },
  arabic: {
    'I’m new': 'أنا جديد في هذا الموقع',
    'Log in': 'تسجيل الدخول',
    'Sign up with Google': 'تسجيل الدخول مع جوجل(Google)',
    'Sign up with Clever': 'تسجيل الدخول مع جوجل(Clever)',
    'Create account': 'إنشاء حساب',
    'Enter your class code': 'أدخل رمز الفصل الدراسي الخاص بك',
    'First name': 'الاسم الأول',
    'Last name': 'الاسم الأخير',
    Summary: 'ملخص',
    'I agree to Ellii’s terms': 'أوافق على الشروط وسياسة الخصوصية',
    'Ellii Student Login Page': 'Ellii صفحة تسجيل الدخول لطلاب',
    'What’s your name?': 'ما اسمك؟',
    'What’s your email?': 'ما هو بريدك الإلكتروني؟',
    'Welcome back!': 'مرحبا بك مجددا!',
    'Terms and Conditions': 'الشروط والأحكام',
    'Create an Ellii student account': 'أنشئ حساب طالب Ellii',
    Email: 'البريد الإلكتروني',
    Password: 'كلمه السر',
    'Create a password': 'إنشاء كلمة مرور',
    'Log in with Google': 'تسجيل الدخول باستخدام Google',
    'Log in with Clever': 'تسجيل الدخول باستخدام Clever',
    Welcome: 'أهلاً وسهلاً',
  },
  italian: {
    'I’m new': 'Sono nuovo su questo sito.',
    'Log in': 'Accedi',
    'Sign up with Google': 'Iscriviti con Google.',
    'Sign up with Clever': 'Iscriviti con Clever.',
    'Create account': 'Crea un account',
    'Enter your class code': 'Inserisci il tuo codice classe',
    'First name': 'Nome',
    'Last name': 'Cognome',
    Summary: 'Riepilogo',
    'I agree to Ellii’s terms': 'Accetto i termini e la politica sulla privacy',
    'Ellii Student Login Page': 'Pagina di accesso per gli studenti di Ellii',
    'What’s your name?': 'Come ti chiami?',
    'What’s your email?': 'Qual è la tua email?',
    'Welcome back!': 'Bentornato!',
    'Terms and Conditions': 'Termini e condizioni',
    'Create an Ellii student account': 'Crea un account studente Ellii',
    Email: 'Email',
    Password: 'Password',
    'Create a password': 'Crea una password',
    'Log in with Google': 'Accedi con Google',
    'Log in with Clever': 'Accedi con Clever',
    Welcome: 'Benvenuto',
  },
  turkish: {
    'I’m new': 'Bu siteye yeni geldim',
    'Log in': 'Oturum aç',
    'Sign up with Google': 'Google ile kaydol',
    'Sign up with Clever': 'Clever ile kaydol',
    'Create account': 'Bir hesap oluştur',
    'Enter your class code': 'Sınıf kodunuzu girin',
    'First name': 'İsim',
    'Last name': 'Soyadı',
    Summary: 'Özet',
    'I agree to Ellii’s terms':
      'Şartları ve gizlilik politikasını kabul ediyorum',
    'Ellii Student Login Page': 'Ellii Öğrenci Giriş Sayfası',
    'What’s your name?': 'Adın ne',
    'What’s your email?': 'E-posta adresin nedir',
    'Welcome back!': 'Tekrar hoş geldiniz',
    'Terms and Conditions': 'Şartlar ve koşullar',
    'Create an Ellii student account': 'Bir Ellii öğrenci hesabı oluştur',
    Email: 'E-posta',
    Password: 'Şifre',
    'Create a password': 'Bir şifre oluştur',
    'Log in with Google': 'Google ile giriş yap',
    'Log in with Clever': 'Clever ile giriş yap',
    Welcome: 'Hoş geldiniz',
  },
  polish: {
    'I’m new': 'Jestem nowy na tej stronie',
    'Log in': 'Zaloguj się',
    'Sign up with Google': 'Zarejestruj się za pomocą Google',
    'Sign up with Clever': 'Zarejestruj się za pomocą Clever',
    'Create account': 'Utwórz konto',
    'Enter your class code': 'Wprowadź kod swojej klasy',
    'First name': 'Imię',
    'Last name': 'Nazwisko',
    Summary: 'Podsumowanie',
    'I agree to Ellii’s terms':
      'Zgadzam się z regulaminem i polityką prywatności.',
    'Ellii Student Login Page': 'Strona logowania dla studentów Ellii',
    'What’s your name?': 'Jak masz na imię?',
    'What’s your email?': 'Jaki jest twój email?',
    'Welcome back!': 'Witamy z powrotem!',
    'Terms and Conditions': 'Warunki i Zasady',
    'Create an Ellii student account': 'Utwórz konto studenta Ellii',
    Email: 'Email',
    Password: 'Hasło',
    'Create a password': 'Utwórz hasło',
    'Log in with Google': 'Zaloguj się za pomocą Google.',
    'Log in with Clever': 'Zaloguj się za pomocą Clever.',
    Welcome: 'Witamy',
  },
}

export default locMap
